module.exports = {
  bcmAdmin: {
    key: 'bcmAdmin',
    label: 'BCM Admin',
  },
  orgAdmin: {
    key: 'orgAdmin',
    label: 'Org Admin',
  },
  providerAP: { // Authorization privileged provider
    key: 'providerAP',
    label: 'Admin Provider',
  },
  providerLP: { // Limited privileged provider
    key: 'providerLP',
    label: 'Provider',
  },
  providerEM: {
    key: 'providerEM',
    label: 'Emergency Provider',
  },
  provider: {
    key: 'provider',
    label: 'All Providers'
  },
  patient: {
    key: 'patient',
    label: 'Patient',
  },
  person: {
    key: 'person',
    label: 'Person',
  },
  dataContributor: {
    key: 'dataContributor',
    label: 'Data Contributor',
  },
};